import{isReportsPage as r}from"./reports.js";var o=("production"===process.env.REACT_APP_ENVIRONMENT||"beta"===process.env.REACT_APP_ENVIRONMENT)&&!r;export{o as isLoggingToGoogleAnalytics};
